var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ntitle"},[_c('div',{staticClass:"left-name YouSheBiaoTiHei2",on:{"click":_vm.goLink}},[_vm._t("default")],2),_vm._t("control")],2)}
var staticRenderFns = []

export { render, staticRenderFns }